import type { App } from '../App';

export type SplitTestConfig = {
  newUserTestSlug: string | null;
  returningUserTestSlug: string | null;
  rollOutConditions?: (app: App) => boolean;
  manualRollOut?: boolean;
  manualTracking?: boolean;
  targetedLanguages?: string[];
  excludedLanguages?: string[];
  distributions: number;
  onActive?: (app: App, distribution: number) => void;
};
export type TestSlug = string;

export type Distribution = number;

export type ActiveSplitTests = Record<TestSlug, Distribution>;

export enum SplitTestStatus {
  Active = 'ACTIVE',
  Full = 'FULL',
  Inactive = 'INACTIVE',
}

export type SplitTestService = {
  getSplitTestStatus(testSlug: string): Promise<SplitTestStatus | null>;
  getDistribution(testSlug: string): Promise<number | null>;
};

export type FetchSplitTestConfig = {
  savedSplitTests: ActiveSplitTests;
  splitTestHandler: SplitTestService;
  user: { isFirstSession: boolean };
  supportedTests: SplitTestConfig[];
};
